module.exports = __webpack_public_path__ + "static/media/RequestAccess-LP.77d5c40b.jpg";